/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Errorfallbackbtncopy3Inputs */



/**
* | output |
* | --- |
* | "Copy" |
*
* @param {Errorfallbackbtncopy3Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const errorfallbackbtncopy3 = /** @type {((inputs?: Errorfallbackbtncopy3Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Errorfallbackbtncopy3Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Copy")
	if (locale === "es") return /** @type {LocalizedString} */ ("Copiar")
	return /** @type {LocalizedString} */ ("Скопировать")
});
export { errorfallbackbtncopy3 as "errorFallbackBtnCopy" }